import { Route, Switch, useLocation } from "react-router-dom";

import ContentWrapper from "theme/components/wrappers/ContentWrapper";
import CookieInformation from "core-web/components/CookieInformation";
import Cookies from "js-cookie";
import ErrorCatcher from "core-web/components/ErrorCatcher";
import Header from "theme/components/Header";
import Modal from "theme/components/Modal";
import Overlay from "theme/components/Overlay";
import Popup from "theme/components/Popup";
import SiteBackground from "theme/components/SiteBackground";
import getQueryParams from "core-web/utils/getQueryParams";
import getUser from "core-web/state/models/User/dispatches/getUser";
import { inServer } from "core-web/constants";
import loadable from "@loadable/component";
import styled from "theme/libs/styled";
import { useEffect } from "react";
import useScrollbarWidth from "core-web/hooks/useScrollbarWidth";
import { useSelector } from "react-redux";
import showOverlay from "core-web/state/models/Overlay/dispatches/showOverlay";
import { getLanguages } from "core-web/utils/multimarket";

const RouteResolver = loadable(() => import("core-web/components/RouteResolver"));
const ThemeProvider = loadable(() => import("core-web/components/ThemeProvider"));
const PageTransitionOverlay = loadable(() => import("core-web/components/PageTransitionOverlay"));
const Gtm = loadable(() => import("core-web/components/Tracking/GTM"));

const SiteWrapper = loadable(() => import("theme/components/wrappers/SiteWrapper"));
const Footer = loadable(() => import("theme/components/Footer"));

const MaxWidthWrapper = styled("div", { shouldForwardProp: (prop) => ["scrollBarWidth"].indexOf(prop) === -1 })`
    width: 100vw;

    &[data-is-checkout-view="false"] {
        max-width: ${({ theme }) => theme.variables.maxWidth};
        margin: 0 auto;

        @media screen and (min-width: ${({ theme }) => theme.variables.maxWidth}) {
            padding-right: 0 !important;
        }

        padding-right: ${({ scrollBarWidth }) => scrollBarWidth};
    }
`;

const Site = () => {
    const { applicationId, locale } = useSelector(({ application }) => application);
    const isCheckout = useSelector(({ page }) => page.type === "storm_checkout");
    const location = useLocation();
    const { update: updateScrollbarWidth, scrollbarWidth } = useScrollbarWidth();
    const currentSiteLanguage = getLanguages(locale.split("_")?.[1]);

    useEffect(() => {
        const fetchData = async () => {
            if (!inServer && Cookies.get("user_logged_in") === "true") {
                getUser();
            }
        };

        fetchData();

        const queryParams = getQueryParams(location);
        if (queryParams.click) {
            Cookies.set("retrack_click", queryParams.click, { expires: 3 });
        }
    }, []);

    useEffect(() => {
        updateScrollbarWidth();
    }, []);

    useEffect(() => {
        if (locale === "en_US") {
            return;
        }
        const shouldShowOverlay =
            ((currentSiteLanguage === "SE" && window.countryCode !== "SE") ||
                (currentSiteLanguage === "GB" && window.countryCode === "SE")) &&
            !Cookies.get("site_selector_cookie") &&
            window.countryCode !== "undefined" &&
            typeof window.countryCode !== "undefined";

        if (shouldShowOverlay) {
            showOverlay("wrong_country_overlay");
        }
    }, []);

    return (
        <ThemeProvider>
            {applicationId === null ? (
                <></>
            ) : (
                <>
                    <ErrorCatcher>
                        <Overlay />
                    </ErrorCatcher>
                    <ErrorCatcher>
                        <Popup />
                    </ErrorCatcher>
                    <ErrorCatcher>
                        <Modal />
                    </ErrorCatcher>
                    <SiteWrapper isCheckoutView={isCheckout}>
                        <ErrorCatcher>
                            <CookieInformation />
                        </ErrorCatcher>
                        <ErrorCatcher>
                            <Gtm />
                        </ErrorCatcher>
                        <ErrorCatcher>
                            <Header />
                        </ErrorCatcher>
                        <ErrorCatcher>
                            <SiteBackground>
                                <MaxWidthWrapper
                                    data-is-checkout-view={isCheckout}
                                    scrollBarWidth={`${scrollbarWidth}px`}
                                >
                                    <ContentWrapper>
                                        <PageTransitionOverlay />
                                        <Switch>
                                            {
                                                // Find a way for both of these to use RouteResolver in a single <Route />
                                                // This works for now.
                                            }
                                            <Route exact path="/" component={RouteResolver} />
                                            <Route path="/:slug" component={RouteResolver} />
                                        </Switch>
                                    </ContentWrapper>
                                </MaxWidthWrapper>
                            </SiteBackground>
                        </ErrorCatcher>
                        <ErrorCatcher>
                            <Footer />
                        </ErrorCatcher>
                    </SiteWrapper>
                </>
            )}
        </ThemeProvider>
    );
};

export default Site;

export { Site as DefaultSite };
